import { render, staticRenderFns } from "./EDPermissionsForm.vue?vue&type=template&id=78843233&"
import script from "./EDPermissionsForm.vue?vue&type=script&lang=js&"
export * from "./EDPermissionsForm.vue?vue&type=script&lang=js&"
import style0 from "./EDPermissionsForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78843233')) {
      api.createRecord('78843233', component.options)
    } else {
      api.reload('78843233', component.options)
    }
    module.hot.accept("./EDPermissionsForm.vue?vue&type=template&id=78843233&", function () {
      api.rerender('78843233', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/documentManagement/vistas/modals/EDPermissionsForm.vue"
export default component.exports